/*  ========================================================================
    # Scripts - Page Status
    ========================================================================  */

/**
 * Script that checks the current status of the page and adds the corresponding
 * classes to the html tag.
 */

const PageStatus = {
  cfg: {
    html: document.querySelector('html'),
    states: {
      loading: 'page-loading',
      complete: 'page-complete',
      scrolled: 'page-scrolled'
    }
  },

  /**
   * Check if the device in use supports touch input and this is also the main input method.
   */
  checkDevice() {
    const isTouch = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isMobile = () => window.matchMedia('(pointer: coarse)').matches;
    this.cfg.html.classList.add(`device-${isTouch() && isMobile() ? 'touch' : 'no-touch'}`);
  },

  /**
   * Add "page-loading".
   */
  pageLoading() {
    this.cfg.html.classList.add(this.cfg.states.loading);
  },

  /**
   * Remove "page-loading" and add "page-complete" when the page is loaded.
   */
  pageComplete() {
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        setTimeout(() => {
          this.cfg.html.classList.remove(this.cfg.states.loading);
          this.cfg.html.classList.add(this.cfg.states.complete);
        }, 1000);
      }
    };
  },

  /**
   * Add "page-scrolled" when the page is scrolled past 200px.
   */
  pageScrolled() {
    window.onscroll = () => {
      setTimeout(() => {
        if (window.scrollY >= 200) {
          this.cfg.html.classList.add(this.cfg.states.scrolled);
        } else {
          this.cfg.html.classList.remove(this.cfg.states.scrolled);
        }
      }, 750);
    };
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.html.classList.contains('js')) {
      this.checkDevice();
      this.pageLoading();
      this.pageComplete();
      this.pageScrolled();
    }
  }
};

export default PageStatus;
